import { useEffect, useState } from 'react';
import { useDebounce } from 'react-use';

export const useDebouncedSearch = () => {
  const [searchValue, setSearchValue] = useState('');

  const [debouncedSearchValue, setDebouncedSearchValue] = useState('');
  const [, cancel] = useDebounce(
    () => {
      setDebouncedSearchValue(searchValue);
    },
    500,
    [searchValue, setDebouncedSearchValue],
  );

  useEffect(() => {
    return () => {
      cancel();
    };
  }, [cancel]);

  return {
    searchValue,
    setSearchValue,
    debouncedSearchValue,
  };
};
